import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../services/Auth/auth.service';
import { Booking, BookingService } from '../../../services/Booking/booking.service';
import moment from 'moment';
import { PageService } from '../../../services/Page/page.service';
import { MomentFormatPipe } from "../../../moment.pipe";
import { DashBookingCardComponent } from "../dash-booking-card/dash-booking-card.component";


@Component({
    selector: 'app-dashboard-booking-past',
    imports: [
    CommonModule,
    RouterModule,
    MomentFormatPipe,
    DashBookingCardComponent
],
    templateUrl: './dashboard-booking-past.component.html',
    styleUrl: './dashboard-booking-past.component.scss'
})
export class DashboardBookingPastComponent {

public hashmap: Map<string, Booking[]> = new Map();
    public isLoaded: boolean = false

    constructor(
        public authService: AuthService,
        public bookingService: BookingService,
        public pageService: PageService
    ) {
        this.bookingService.getApprovedAll().subscribe(res => {
            this.isLoaded = false
            this.hashmap.clear()
            let now = new Date()

            res = res.filter((booking) => booking.endDate.toDate() < now  );

            let ids: number[] = res.map(item => item.Dx)

            this.pageService.getMoviesByIds(ids).then(movies => {
                movies.forEach(movie => {
                    res.forEach(booking => {
                        if (booking.Dx == movie.Dx) {
                            booking.movie = movie
                        }
                    })
                })

                res.sort((a, b) => b.created.toMillis() - a.created.toMillis())

                res.forEach(request => {
                    var itemDate = moment(request.created.toDate()).format('dddd, MMMM D, YYYY')

                    var list = this.hashmap.get(itemDate)
                    if (list == undefined || list == null) {
                        list = []
                    }
                    list.push(request)
                    this.hashmap.set(itemDate, list)
                })

                setTimeout(() => {
                    this.isLoaded = true
                }, 300);
            })



        })
    }
}


